export default function accordionScript() {

  const accordions = document.querySelectorAll('.c-accordion__accordion');
  const SCROLL_DELAY = 300; // wait for DOM + maxHeight updates

  const getHeaderOffset = () => {
    const header = document.querySelector('.c-header');
    return header ? header.offsetHeight + 15 : 0;
  };

  const scrollToItem = (item) => {
    const header = item.querySelector('.c-accordion__accordion-item-header');
    if (!header) return;

    setTimeout(() => {
      const offset = getHeaderOffset();
      const rect = header.getBoundingClientRect();

      window.scrollTo({
        top: window.pageYOffset + rect.top - offset,
        behavior: 'smooth',
      });
    }, SCROLL_DELAY);
  };

  const openAccordion = (item) => {
    const content = item.querySelector('.c-accordion__accordion-content');
    item.classList.add('c-accordion__accordion-item--active');
    content.style.maxHeight = content.scrollHeight + 'px';
  };

  const closeAccordion = (item) => {
    const content = item.querySelector('.c-accordion__accordion-content');
    item.classList.remove('c-accordion__accordion-item--active');
    content.style.maxHeight = null;
  };

  accordions.forEach((accordion) => {

    if (accordion.classList.contains('c-accordion__accordion--links')) return;

    const items = accordion.querySelectorAll('.c-accordion__accordion-item');
    if (!items.length) return;

    items.forEach((item) => {
      const header = item.querySelector('.c-accordion__accordion-item-header');
      const content = item.querySelector('.c-accordion__accordion-content');

      if (!header || !content) return;

      header.onclick = () => {
        const isOpen = item.classList.contains('c-accordion__accordion-item--active');

        if (isOpen) {
          // close only – no scroll
          closeAccordion(item);
          return;
        }

        // close others first
        items.forEach((i) => {
          if (i !== item) closeAccordion(i);
        });

        // open clicked item
        openAccordion(item);

        // scroll ONLY for newly opened item
        scrollToItem(item);
      };
    });

    if (accordion.classList.contains('c-accordion--expand-first')) {
      openAccordion(items[0]);
    }

  });
}
